import AbstractWebsiteEntertainmentModel from './AbstractWebsiteEntertainmentModel';
import { RenderNameProps }               from '@widesk-ui/mixins/ApiModelRenderName';
import doc                               from '@widesk-core/decorators/doc';
import FondationsEntertainmentModel      from '@models/fondations/EntertainmentModel';
import { getLocale }                     from '@widesk-core/locale';

@doc.urnResource('website_entertainment')
export default class WebsiteEntertainmentModel extends AbstractWebsiteEntertainmentModel {
	declare protected _tsFilters: AbstractWebsiteEntertainmentModel['_tsFilters'] & {
		'tags[jts:registry:service:website][display_in_sidebar]': id;
	};

	public renderName(props?: RenderNameProps<this> & WebsiteEntertainmentNameProps) {
		return super.renderName(props);
	}

	@doc.modelUrn(FondationsEntertainmentModel) declare entertainment: FondationsEntertainmentModel;

	static get urlPrefix() {
		return `/${getLocale()}/editions/`;
	}

	get url() {
		return WebsiteEntertainmentModel.urlPrefix + this.slugPrefix;
	}

	get urlWithLangWildcard() {
		return `/[LANG]/editions/` + this.slugPrefix;
	}
}
